import { useQuery, useSubscription } from '@apollo/client';
import useAuthorization from '@hooks/useAuthorization';
import useAppFeatures from '@hooks/useAppFeatures';
import { UNREAD_REPORTS } from '@graphql/operations/communitySafety/unreadReports';
import { ON_UPDATE_UNREAD_COUNT_SUBSCRIPTION } from '@graphql/operations/communitySafety/onUpdateUnreadCount';

/**
 * Hook to fetch the number of unread reports for the current moderator
 * and subscribe to updates
 * Skips if the user isn't a moderator
 */
const useUnreadReportPostCount = (eventId?: string, attendeeId?: string) => {
  const { communitySafety } = useAppFeatures();
  const { loading: meLoading, canModerateASession } = useAuthorization();
  const skip = !canModerateASession() || !communitySafety || !eventId || !attendeeId;

  const { data, loading, error } = useQuery(UNREAD_REPORTS, {
    skip
  });

  useSubscription(ON_UPDATE_UNREAD_COUNT_SUBSCRIPTION, {
    variables: { eventId, attendeeId },
    skip
  });

  return {
    unreadReportCount: data?.unreadReports?.unreadCount || 0,
    loading: loading || meLoading,
    error
  };
};

export default useUnreadReportPostCount;
